export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName =
      favicon.dataset.badgeIcon ||
      `/favicon-badge-${favicon.getAttribute('sizes') || favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      document.querySelectorAll('.favicon').forEach(favicon => {
        const oldFileName =
          favicon.dataset.defaultIcon ||
          `/favicon-${favicon.getAttribute('sizes') || favicon.sizes[[0]]}.png`;
        favicon.href = oldFileName;
      });
    }
  });
};
